export default [
  {
    "title": "Collageen - Bokser",
    "video": "https://res.cloudinary.com/dnbztsrik/video/upload/f_auto:video,q_auto/v1/saus/collageen_-_bokser_z740mj", // collageen - bokser.mp4 (add mp4 url later)
    "description": `Regie: Sikko Medema\nD.O.P.: Mike De Jong\nCreatief producent: Isabel de Jongh\nProductie: Stijn Zandstra\nIn opdracht van: Glass Creative Studio`,
    "fullVideo": "https://vimeo.com/1099341513/08a072cf67"
  },
  {
    "title": "Collageen - Danser",
    "video": "https://res.cloudinary.com/dnbztsrik/video/upload/f_auto:video,q_auto/v1/saus/collageen_-_danser_dek6hk", // collageen - danser.mp4 (add mp4 url later)
    "description": `Regie: Sikko Medema\nD.O.P.: Mike De Jong\nCreatief producent: Isabel de Jongh\nProductie: Stijn Zandstra\nIn opdracht van: Glass Creative Studio`,
    "fullVideo": "https://vimeo.com/1099341421/4d053da92a?share=copy"
  },
  {
    "title": "Awakenings Upclose & Personal: Fafi Abdel Nour",
    "video": "https://res.cloudinary.com/dnbztsrik/video/upload/f_auto:video,q_auto/v1/saus/Upclose_Fafi_Website_opuora", // Upclose Fafi Website.mp4 (add mp4 url later)
    "description": `Regie, camera en montage: Sikko Medema\nRedactie en presentatie: Nanook van der Pol`,
    "fullVideo": "https://vimeo.com/1086073691/de023e9dac"
  }
]
